import i18next from "src/i18n/config";
import AuthService from "src/services/authService";
import { downloadFromBlob } from "src/ui/utils/download";

import productsApi from "@dashboard/products/api/apiClient";
import { toAppUrl } from "@services/configService";
import TimeService from "@services/timeService/timeService";
import { showErrorToast } from "@shared/toasts/Toasts";

export function getReasonMessage(hasLogs: boolean) {
    if (!hasLogs) {
        return i18next.t("common:section.logStreamer.noLogsAvailable");
    }
    return i18next.t("common:section.logStreamer.showBuildLogs");
}
export function onStartStreaming(buildId: number) {
    const token = AuthService.getSession()?.access_token;
    if (!token) {
        throw new Error(i18next.t("common:section.logStreamer.errorRetrievingLogs"));
    }
    return productsApi.streamBuildLog(buildId, token);
}
export async function onDownloadLog(buildId: number) {
    try {
        const { data } = await productsApi.downloadBuildLog(buildId);
        if (!data?.size) {
            return showErrorToast(i18next.t("common:section.logStreamer.logFileEmpty"));
        }

        const name = `log${buildId}_${TimeService.getNowInFormat("yyyy-LL-dd")}`;
        downloadFromBlob(data, name);
    } catch (_error) {
        showErrorToast(i18next.t("common:section.logStreamer.downloadLogsFailed"));
    }
}

type LogLinkParams = {
    buildId: number;
    codename: string;
    androidVersion: string;
    workspaceGuid: string;
};

export function buildLogLink(params: LogLinkParams) {
    const path = toAppUrl(
        `/dashboard/products/${encodeURIComponent(params.codename)}/${encodeURIComponent(params.androidVersion)}`,
    );
    const query = new URLSearchParams({ log: String(params.buildId), workspace: params.workspaceGuid });
    return new URL(`${path}?${query.toString()}`, window.location.origin).toString();
}
